import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import useService from "../../../../../hooks/useService";
import { mapProviderContractData } from "../helper/functions";
import { useProviderDetailStore } from "../store/provider-details/providerDetailStore";

const EMPTY_CONTRACT_VALUES = {
  contractEntity: "",
  ein: "",
  contractStartDate: "",
  contractEndDate: "",
};

export default function useProviderContractDetails() {
  const providerRepository = useService("repositories/provider-repository");
  const { id: providerId } = useParams();
  const { initialData, setInitialData, setModifiedData } = useProviderDetailStore();
  const initializedEntityRef = useRef();

  useEffect(() => {
    const syncInitialContract = async () => {
      if (!providerId) {
        return;
      }

      if (initializedEntityRef.current === initialData?.entity && initialData?.contractEntity) {
        return;
      }

      initializedEntityRef.current = initialData?.entity;

      try {
        const response = await providerRepository.getContract(providerId);
        const contractValues = mapProviderContractData(response);
        const currentInitialData = useProviderDetailStore.getState().initialData;
        const currentModifiedData = useProviderDetailStore.getState().modifiedData;
        setInitialData({ ...currentInitialData, ...contractValues });
        setModifiedData({ ...currentModifiedData, ...contractValues });
      } catch (error) {
        console.error(error);
        const currentInitialData = useProviderDetailStore.getState().initialData;
        const currentModifiedData = useProviderDetailStore.getState().modifiedData;
        setInitialData({ ...currentInitialData, ...EMPTY_CONTRACT_VALUES });
        setModifiedData({ ...currentModifiedData, ...EMPTY_CONTRACT_VALUES });
      }
    };

    syncInitialContract();
  }, [
    initialData?.contractEntity,
    initialData?.entity,
    providerId,
    providerRepository,
    setInitialData,
    setModifiedData,
  ]);
}
